import { Col, Row, Stack } from "react-bootstrap";
import { renderTrendIcon } from "../helperRenders";

export default function HybridHitlistRow({ item, setCatalogueSong, airplayMix }) {
    return (
        <Row className={`py-1 border-bottom hoverable`} onClick={() => setCatalogueSong(item.song)}>
            <Col xs={3} xl={1} className=" align-content-center text-center d-none d-xl-block">
                #{item.rank}
            </Col>
            <Col xs={3} xl className=" align-content-center d-none d-xl-block">
                {item.song.artist}
            </Col>
            <Col xs={3} xl className=" align-content-center d-none d-xl-block">
                {item.song.title}
            </Col>
            <Col xs={2} xl={2} className="align-content-center text-center d-none d-xl-block">
                {item.song.release_year}
            </Col>
            <Col xs={12} className=" d-xl-none ">
                <Stack direction="horizontal" gap={1} className=" fw-bold flex-wrap">
                    <span className={airplayMix ? "me-1" : ""}>#{item.rank}</span>
                    {!airplayMix && <span className="d-flex me-1">{renderTrendIcon(item.trend)}</span>}
                    <span>{item.song.artist}</span>
                    <span>-</span>
                    <span>{item.song.title}</span>
                    {item.song.release_year && <span>({item.song.release_year})</span>}
                </Stack>
            </Col>
            {airplayMix ? (
                <>
                    <Col xs={"auto"} xl={1} className=" align-content-center text-center">
                        <span className=" d-xl-none">Digital Rank: </span>
                        <span className=" fw-bold fw-xl-normal">{item.digital_rank ?? "-"}</span>
                    </Col>
                    <Col xs={"auto"} xl={1} className=" align-content-center text-center">
                        <span className=" d-xl-none">Airplay Rank: </span>
                        <span className=" fw-bold fw-xl-normal">{item.airplay_rank ?? "-"}</span>
                    </Col>
                    <Col xs={"auto"} xl={1} className="d-flex align-items-center justify-content-center column-gap-1 ">
                        <span className=" d-xl-none">Trend: </span>
                        <Stack direction="horizontal" gap={1}>
                            <span className="fw-bold fw-xl-normal">{item.previous_rank ?? "-"}</span>
                            <span className="d-flex">{renderTrendIcon(item.trend)}</span>
                        </Stack>
                    </Col>
                </>
            ) : (
                <Col xl={1} className="d-none d-xl-flex align-items-center justify-content-center">
                    {renderTrendIcon(item.trend)}
                </Col>
            )}
        </Row>
    );
}
